export default "__VITE_ASSET__Pqtvsgnt__"